const assessmentMetaData = [
  //css intermediate , advance
  {
    technology: "CSS",
    level: "Intermidiate",
    description:
      "Focused assessment on intermediate CSS topics such as box model, positioning, pseudo-classes, and responsive layouts.",
    stats: {
      passingPercentage: "70%",
      attemptsAllowed: 3,
      rating: 4.7,
      students: 12000,
    },
    topicsCovered: [
      "Box Model & Positioning",
      "Display & Overflow",
      "Pseudo-classes & Pseudo-elements",
      "Responsive Units (%, em, rem, vw, vh)",
      "Transitions & Basic Animations",
      "Z-index and Stacking Context",
      "CSS Variables (Custom Properties)",
    ],
    prerequisites: [
      "Understanding of basic HTML structure",
      "Familiarity with basic CSS properties and selectors",
    ],
    learningObjectives: [
      "Understand and apply the CSS box model effectively.",
      "Use different positioning techniques for page layout.",
      "Implement responsive design using CSS units and media queries.",
      "Create interactive effects using transitions and pseudo-classes.",
      "Manage layout stacking and visibility using z-index and overflow.",
    ],
  },
  {
    technology: "CSS",
    level: "Advance",
    title: "CSS Advance",
    description:
      "Comprehensive evaluation of advanced CSS concepts including Flexbox, Grid, animations, responsive design, and modern layout techniques.",
    stats: {
      passingPercentage: "75%",
      attemptsAllowed: 3,
      rating: 4.9,
      students: 15000,
    },
    topicsCovered: [
      "Flexbox",
      "CSS Grid",
      "Responsive Design",
      "CSS Animations & Transitions",
      "Variables & Custom Properties",
      "Pseudo-classes & Pseudo-elements",
      "Advanced Selectors",
      "Media Queries",
    ],
    prerequisites: [
      "Basic knowledge of HTML and CSS",
      "Familiarity with CSS fundamentals like selectors and properties",
    ],
    learningObjectives: [
      "Design complex, responsive layouts using Flexbox and Grid.",
      "Build adaptive web pages using advanced media queries.",
      "Utilize CSS animations and transitions to enhance user experience.",
      "Leverage CSS variables for maintainable and scalable styles.",
      "Apply advanced selectors and pseudo-elements to refine design precision.",
    ],
  },
  //Express.js Quizzes basic, intermediate, advance
  {

    technology: "Express.js",
    level: "Basic",
    title: "Express.js Basic",
    description:
      "Introduction to Express.js fundamentals including setting up a server, handling routes, and managing requests and responses.",
    stats: {
      passingPercentage: "65%",
      attemptsAllowed: 3,
      rating: 4.6,
      students: 10000,
    },
    topicsCovered: [
      "Introduction to Express.js",
      "Setting up Express Server",
      "Routing Basics",
      "Request and Response Handling",
      "Serving Static Files",
      "Middleware Fundamentals",
    ],
    prerequisites: [
      "Basic understanding of JavaScript",
      "Knowledge of Node.js fundamentals",
    ],
    learningObjectives: [
      "Understand the role of Express.js in Node.js web applications.",
      "Set up and configure a basic Express.js server.",
      "Handle HTTP requests and responses effectively.",
      "Define and manage simple routes.",
      "Serve static files using built-in middleware.",
    ],
  },
  {
    technology: "Express.js",
    level: "Intermediate",
    title: "Express.js Intermediate",
    description:
      "Assessment of intermediate Express.js concepts like middleware chaining, route parameters, error handling, and RESTful API design.",
    stats: {
      passingPercentage: "70%",
      attemptsAllowed: 3,
      rating: 4.8,
      students: 11000,
    },
    topicsCovered: [
      "Express Router",
      "Route Parameters & Query Strings",
      "Middleware Chaining",
      "Error Handling",
      "Template Engines (EJS, Handlebars)",
      "Environment Variables & Config",
      "RESTful API Basics",
    ],
    prerequisites: [
      "Knowledge of basic Express.js concepts",
      "Understanding of HTTP methods and JSON data",
    ],
    learningObjectives: [
      "Structure applications using Express Router for modular code.",
      "Use route parameters and query strings for dynamic routing.",
      "Implement and chain multiple middleware functions.",
      "Handle runtime errors gracefully using error middleware.",
      "Build simple RESTful APIs and render dynamic templates.",
    ],
  },
  {
    technology: "Express.js",
    level: "Advance",
    title: "Express.js Advance",
    description:
      "Advanced evaluation of Express.js covering authentication, security, performance optimization, and scalable REST API architecture.",
    stats: {
      passingPercentage: "80%",
      attemptsAllowed: 3,
      rating: 4.9,
      students: 13000,
    },
    topicsCovered: [
      "Authentication & Authorization (JWT, OAuth)",
      "Advanced Middleware",
      "Security Best Practices",
      "Performance Optimization",
      "Error Handling & Logging",
      "Integration with Databases (MongoDB, PostgreSQL)",
      "Building Scalable REST APIs",
      "Testing Express Apps",
    ],
    prerequisites: [
      "Strong understanding of Node.js and Express.js fundamentals",
      "Familiarity with REST APIs and database integration",
    ],
    learningObjectives: [
      "Implement secure authentication and authorization mechanisms.",
      "Apply middleware for security and performance improvements.",
      "Integrate databases seamlessly with Express applications.",
      "Optimize Express apps for scalability and performance.",
      "Write unit and integration tests for Express APIs.",
    ],
  },

  //git basic ,intermediate
  {
  technology: "Git",
  level: "Basic",
  title: "Git Basics",
  description:
    "A quiz for beginners to understand the fundamental Git commands, repositories, and version control workflow.",
  stats: {
    passingPercentage: "70%",
    attemptsAllowed: 3,
    rating: 4.7,
    students: 13900,
  },
  topicsCovered: [
    "Version Control Overview",
    "Git Installation and Setup",
    "Initializing and Cloning Repositories",
    "Staging and Committing Changes",
    "Branching Basics",
    "Undoing Changes",
    "Viewing History with Git Log",
    "Working with Remotes",
  ],
  prerequisites: [
    "Basic computer and command-line usage",
    "Understanding of software projects and files",
  ],
  learningObjectives: [
    "Understand version control principles and Git’s core workflow.",
    "Use basic Git commands to manage repositories.",
    "Work with branches to organize project development.",
    "Collaborate using remote repositories like GitHub.",
  ],
},
  {
  technology: "Git",
  level: "Intermediate",
  title: "Git Intermediate",
  description:
    "An intermediate-level quiz on Git focusing on branching, merging, collaboration workflows, conflict resolution, and commit best practices.",
  stats: {
    passingPercentage: "75%",
    attemptsAllowed: 3,
    rating: 4.7,
    students: 15800,
  },
  topicsCovered: [
    "Branching and Merging",
    "Git Merge vs Rebase",
    "Resolving Merge Conflicts",
    "Working with Remote Repositories",
    "Stashing and Cleaning",
    "Commit Best Practices",
    "Git Logs and History",
    "Tagging and Releases",
  ],
  prerequisites: [
    "Basic understanding of version control systems",
    "Knowledge of fundamental Git commands like init, add, commit, and push",
  ],
  learningObjectives: [
    "Understand and apply Git branching and merging strategies effectively.",
    "Differentiate between merge and rebase operations and their appropriate use cases.",
    "Resolve merge conflicts efficiently using Git CLI and tools.",
    "Collaborate using remote repositories like GitHub or GitLab.",
    "Manage and maintain clean commit histories following best practices.",
  ],
},

//mongodb basic , intermediate
{
  technology: "MongoDB",
  level: "Basic",
  title: "MongoDB Basic",
  description:
    "A foundational quiz designed to test your understanding of MongoDB basics, including data modeling, CRUD operations, and fundamental concepts of NoSQL databases.",
  stats: {
    passingPercentage: "70%",
    attemptsAllowed: 3,
    rating: 4.6,
    students: 12400,
  },
  topicsCovered: [
    "Introduction to NoSQL Databases",
    "Understanding Collections and Documents",
    "MongoDB Data Types",
    "Basic CRUD Operations",
    "Using Mongo Shell",
    "Query Operators and Filters",
    "Importing and Exporting Data",
    "Indexes Overview",
  ],
  prerequisites: [
    "Basic knowledge of databases and data storage concepts",
    "Familiarity with JSON structure",
  ],
  learningObjectives: [
    "Understand the core concepts of NoSQL and MongoDB architecture.",
    "Perform basic CRUD operations using Mongo Shell and MongoDB Compass.",
    "Work with collections and documents effectively.",
    "Use query operators to filter and retrieve data.",
    "Gain familiarity with MongoDB tools and interfaces.",
  ],
},
{
  technology: "MongoDB",
  level: "Intermediate",
  title: "MongoDB Intermediate",
  description:
    "A detailed assessment of MongoDB’s intermediate features including aggregation, indexing strategies, schema design, and working with relationships between documents.",
  stats: {
    passingPercentage: "75%",
    attemptsAllowed: 3,
    rating: 4.8,
    students: 13700,
  },
  topicsCovered: [
    "Schema Design Patterns",
    "Aggregation Framework",
    "Indexing and Query Optimization",
    "Data Validation and Schema Enforcement",
    "Working with Embedded and Referenced Documents",
    "Transactions and Atomic Operations",
    "Backup and Restore",
    "Using MongoDB with Node.js",
  ],
  prerequisites: [
    "Strong understanding of MongoDB fundamentals",
    "Experience with basic CRUD and query operations",
  ],
  learningObjectives: [
    "Design efficient and scalable data models using MongoDB best practices.",
    "Leverage the aggregation framework for data analysis and transformation.",
    "Implement and tune indexes to improve query performance.",
    "Manage relationships using embedded and referenced documents.",
    "Perform transactions and maintain data integrity across operations.",
  ],
},
//typescript basic
{
  technology: "TypeScript",
  level: "Basic",
  title: "TypeScript Basic",
  description:
    "A beginner-friendly quiz designed to assess your understanding of TypeScript fundamentals, types, and compiler basics.",
  stats: {
    passingPercentage: "70%",
    attemptsAllowed: 3,
    rating: 4.6,
    students: 11200,
  },
  topicsCovered: [
    "Introduction to TypeScript",
    "Basic Types and Type Inference",
    "Functions and Parameters",
    "Interfaces and Type Aliases",
    "Enums and Tuples",
    "TypeScript Compiler (tsc)",
    "Working with Modules",
    "Basic Error Handling",
  ],
  prerequisites: [
    "Familiarity with JavaScript basics",
    "Understanding of variables, functions, and objects",
  ],
  learningObjectives: [
    "Understand the core features and benefits of TypeScript.",
    "Use basic types and interfaces to define object structures.",
    "Compile and run TypeScript code effectively.",
    "Catch and resolve type-related issues during development.",
  ],
},

//sql intermediate, advance
{
  technology: "SQL",
  level: "Intermediate",
  title: "SQL Intermediate",
  description:
    "A comprehensive quiz focused on intermediate SQL concepts such as joins, subqueries, and aggregation for efficient data retrieval.",
  stats: {
    passingPercentage: "75%",
    attemptsAllowed: 3,
    rating: 4.7,
    students: 14900,
  },
  topicsCovered: [
    "INNER, LEFT, RIGHT, and FULL Joins",
    "Subqueries and Nested Queries",
    "GROUP BY and HAVING Clauses",
    "Aggregate Functions",
    "Views and Aliases",
    "Data Sorting and Filtering",
    "Case Expressions",
    "Constraints and Keys Overview",
  ],
  prerequisites: [
    "Basic understanding of SQL and database concepts",
    "Experience with SELECT, INSERT, UPDATE, DELETE statements",
  ],
  learningObjectives: [
    "Write and optimize complex SQL queries using joins and subqueries.",
    "Use aggregate functions to analyze and summarize data.",
    "Design efficient queries with views and constraints.",
    "Apply grouping and filtering logic in multi-table queries.",
  ],
},
{
  technology: "SQL",
  level: "Advance",
  title: "SQL Advance",
  description:
    "An advanced-level SQL quiz covering indexing, transactions, optimization, stored procedures, and advanced query patterns.",
  stats: {
    passingPercentage: "80%",
    attemptsAllowed: 3,
    rating: 4.9,
    students: 17300,
  },
  topicsCovered: [
    "Indexes and Query Optimization",
    "Stored Procedures and Functions",
    "Triggers and Events",
    "Transactions and ACID Properties",
    "CTEs and Window Functions",
    "Database Normalization",
    "Performance Tuning",
    "Error Handling and Security",
  ],
  prerequisites: [
    "Proficiency in SQL querying and joins",
    "Understanding of relational database concepts",
  ],
  learningObjectives: [
    "Optimize database performance using indexes and execution plans.",
    "Implement stored procedures and triggers for automation.",
    "Understand transaction management and isolation levels.",
    "Use advanced SQL constructs like CTEs and window functions.",
  ],
},

//python intermediate ,advance
{
  technology: "Python",
  level: "Intermediate",
  title: "Python Intermediate",
  description:
    "A quiz designed to test your knowledge of intermediate Python topics including OOP, file handling, and error management.",
  stats: {
    passingPercentage: "75%",
    attemptsAllowed: 3,
    rating: 4.8,
    students: 16200,
  },
  topicsCovered: [
    "Functions and Scope",
    "Object-Oriented Programming",
    "File Handling",
    "Error and Exception Handling",
    "Modules and Packages",
    "Comprehensions",
    "Decorators and Iterators",
    "Working with JSON and CSV",
  ],
  prerequisites: [
    "Basic Python programming knowledge",
    "Familiarity with loops, conditionals, and functions",
  ],
  learningObjectives: [
    "Apply object-oriented principles to structure Python code.",
    "Handle files and exceptions gracefully.",
    "Use list and dictionary comprehensions effectively.",
    "Organize code using modules and packages.",
  ],
},
{
  technology: "Python",
  level: "Advance",
  title: "Python Advance",
  description:
    "An advanced Python quiz focusing on multithreading, asynchronous programming, design patterns, and performance optimization.",
  stats: {
    passingPercentage: "80%",
    attemptsAllowed: 3,
    rating: 4.9,
    students: 14100,
  },
  topicsCovered: [
    "Iterators and Generators Deep Dive",
    "Decorators and Metaclasses",
    "Concurrency with Threads and Asyncio",
    "Context Managers",
    "Regular Expressions",
    "Design Patterns in Python",
    "Performance Optimization Techniques",
    "Working with External APIs",
  ],
  prerequisites: [
    "Strong understanding of Python fundamentals",
    "Experience with intermediate-level Python concepts",
  ],
  learningObjectives: [
    "Implement asynchronous and concurrent code efficiently.",
    "Use advanced Python features like decorators and metaclasses.",
    "Design maintainable systems using common design patterns.",
    "Optimize Python code for better performance and scalability.",
  ],
},

//react intermediate , advance
{
  technology: "React",
  level: "Intermediate",
  title: "React Intermediate",
  description:
    "An intermediate React quiz focusing on component architecture, state management, hooks, and lifecycle handling.",
  stats: {
    passingPercentage: "75%",
    attemptsAllowed: 3,
    rating: 4.8,
    students: 15600,
  },
  topicsCovered: [
    "Functional vs Class Components",
    "React Hooks (useState, useEffect)",
    "Props and State Management",
    "Conditional Rendering",
    "Lists and Keys",
    "React Router Basics",
    "Component Composition",
    "Form Handling",
  ],
  prerequisites: [
    "Basic understanding of JavaScript and ES6",
    "Familiarity with basic React syntax and JSX",
  ],
  learningObjectives: [
    "Build dynamic UI using reusable React components.",
    "Manage state effectively using React hooks.",
    "Implement routing and navigation between pages.",
    "Handle user input and controlled components.",
  ],
},
{
  technology: "React",
  level: "Advance",
  title: "React Advance",
  description:
    "An advanced React quiz covering context API, performance optimization, custom hooks, and integration with external APIs.",
  stats: {
    passingPercentage: "80%",
    attemptsAllowed: 3,
    rating: 4.9,
    students: 14400,
  },
  topicsCovered: [
    "React Context API",
    "Custom Hooks",
    "Performance Optimization (memo, useCallback, useMemo)",
    "Error Boundaries",
    "React Suspense and Lazy Loading",
    "State Management with Redux Toolkit",
    "API Integration with Axios/Fetch",
    "Testing with React Testing Library",
  ],
  prerequisites: [
    "Strong understanding of React fundamentals and hooks",
    "Experience in building functional React applications",
  ],
  learningObjectives: [
    "Optimize React apps for performance and scalability.",
    "Build reusable custom hooks for modular code.",
    "Integrate APIs and manage global state effectively.",
    "Use advanced React features like Context and Suspense.",
  ],
},

//javascript basic ,intermediate, advance
{
  technology: "JavaScript",
  level: "Basic",
  title: "JavaScript Basic",
  description:
    "A beginner quiz to test your knowledge of JavaScript fundamentals, syntax, and core programming concepts.",
  stats: {
    passingPercentage: "70%",
    attemptsAllowed: 3,
    rating: 4.6,
    students: 19800,
  },
  topicsCovered: [
    "Variables and Data Types",
    "Operators and Expressions",
    "Conditional Statements",
    "Loops and Iterations",
    "Functions Basics",
    "Arrays and Objects",
    "DOM Introduction",
    "Events Basics",
  ],
  prerequisites: [
    "Basic understanding of HTML and CSS",
    "Interest in learning programming concepts",
  ],
  learningObjectives: [
    "Understand fundamental JavaScript syntax and data types.",
    "Work with loops, functions, and conditionals.",
    "Manipulate arrays and objects effectively.",
    "Write simple scripts to interact with the browser.",
  ],
},
{
  technology: "JavaScript",
  level: "Intermediate",
  title: "JavaScript Intermediate",
  description:
    "A quiz for intermediate learners focusing on ES6 features, asynchronous JavaScript, and DOM manipulation.",
  stats: {
    passingPercentage: "75%",
    attemptsAllowed: 3,
    rating: 4.7,
    students: 17600,
  },
  topicsCovered: [
    "ES6 Syntax (let, const, arrow functions)",
    "Destructuring and Spread Operator",
    "Promises and Async/Await",
    "DOM Manipulation and Events",
    "Modules and Imports/Exports",
    "Template Literals",
    "Error Handling",
    "APIs and Fetch",
  ],
  prerequisites: [
    "Familiarity with JavaScript basics",
    "Knowledge of HTML and browser environment",
  ],
  learningObjectives: [
    "Master ES6 syntax and features for cleaner code.",
    "Understand asynchronous programming with promises.",
    "Manipulate the DOM using modern JavaScript techniques.",
    "Integrate APIs and handle data dynamically.",
  ],
},
{
  technology: "JavaScript",
  level: "Advance",
  title: "JavaScript Advance",
  description:
    "An advanced JavaScript quiz focusing on closures, prototypes, event loop, and performance optimization.",
  stats: {
    passingPercentage: "80%",
    attemptsAllowed: 3,
    rating: 4.9,
    students: 13200,
  },
  topicsCovered: [
    "Closures and Scope",
    "Prototype and Inheritance",
    "Event Loop and Async Handling",
    "Advanced Functions and Currying",
    "Memory Management",
    "Modules and Bundling",
    "Performance Optimization",
    "Design Patterns in JavaScript",
  ],
  prerequisites: [
    "Strong understanding of JavaScript fundamentals",
    "Experience with ES6 features and DOM programming",
  ],
  learningObjectives: [
    "Deeply understand the event loop and asynchronous flow.",
    "Implement closures, prototypes, and object-oriented concepts.",
    "Apply best practices for optimizing JS performance.",
    "Use advanced JavaScript patterns in real-world applications.",
  ],
},

//nodejs basic 
{
  technology: "Node.js",
  level: "Basic",
  title: "Node.js Basic",
  description:
    "An introductory quiz on Node.js covering its architecture, core modules, and fundamental server-side programming concepts.",
  stats: {
    passingPercentage: "70%",
    attemptsAllowed: 3,
    rating: 4.6,
    students: 12200,
  },
  topicsCovered: [
    "Introduction to Node.js and NPM",
    "Modules and require()",
    "File System Operations",
    "Event Loop Basics",
    "Creating HTTP Server",
    "Streams and Buffers",
    "Handling Asynchronous Operations",
    "Basic Error Handling",
  ],
  prerequisites: [
    "Knowledge of JavaScript fundamentals",
    "Basic understanding of backend concepts",
  ],
  learningObjectives: [
    "Understand Node.js runtime and architecture.",
    "Use built-in modules to perform file and network operations.",
    "Handle asynchronous operations with callbacks and promises.",
    "Build simple HTTP servers using Node.js.",
  ],
},
];


export default assessmentMetaData;